import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { EMRService } from 'app/EMR/EMR.service';
import { IolModel } from 'app/EMR/EMRModels/iol.model';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DialogData } from 'app/reports/reportdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-iol',
  templateUrl: './iol.component.html',
  styleUrls: ['./iol.component.scss']
})
export class IOLComponent implements OnInit {
  detailiolArray: any = [];
  saveiolArray: IolModel = {};
  destroyiol$: Subject<boolean> = new Subject<boolean>();
  constructor(private dialogRef: MatDialogRef<IOLComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,private dialog: MatDialog, private emrService: EMRService, private dashboardService: DashboardService,private authService:AuthService,private datePipe:DatePipe) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.detailiolArray=[];
    this.saveiolArray={};
    if (this.emrService.visitid) {
      this.getIolSaveDetail(0, this.emrService.visitid);
    }
  }
  ngOnDestroy() {
    this.destroyiol$.next(true);
    this.destroyiol$.unsubscribe();
    this.saveiolArray=null;
    this.detailiolArray=null;
  }
  closedialog() {
    this.dialogRef.close();

  }
 
  getIolSaveDetail(iolid, visitid) {
    this.emrService.getiolsaveData(iolid, visitid).pipe(takeUntil(this.destroyiol$)).subscribe((x: any) => {
      if(x.length >0){
        this.saveiolArray = x[0];
        this.saveiolArray.isEdit =true;
        this.getIolDetail();
      }else{
       this.setdata();
      }
     
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  setdata(){
    this.saveiolArray.isEdit =false;
    this.saveiolArray.pK_IOLId =0;
    this.saveiolArray.fK_VisitId=this.emrService.visitid;
    this.saveiolArray.isActive=true;
    this.saveiolArray.machineName=null;
    this.saveiolArray.userName=null;
    this.saveiolArray.k1Rt=null;
    this.saveiolArray.k1Lt=null;
    this.saveiolArray.k2Rt=null;
    this.saveiolArray.k2Lt=null;
    this.saveiolArray.k1AxisRt=null;
    this.saveiolArray.k1AxisLt=null;
    this.saveiolArray.k2AxisRt=null;
    this.saveiolArray.k2AxisLt=null;
    this.saveiolArray.alRt=null;
    this.saveiolArray.alLt=null;
    this.saveiolArray.aConst1Rt=null;
    this.saveiolArray.aConst1Lt=null;
    this.saveiolArray.iolRemarks=null;
    this.saveiolArray.power1Rt=null;
    this.saveiolArray.power1Lt=null;
    this.saveiolArray.aConst2Rt=null;
    this.saveiolArray.aConst2Lt=null;
    this.saveiolArray.power2Rt=null;
    this.saveiolArray.power2Lt=null;
    this.saveiolArray.aConst3Rt=null;
    this.saveiolArray.aConst3Lt=null;
    this.saveiolArray.aConst4Rt=null;
    this.saveiolArray.aConst4Lt=null;
    this.saveiolArray.power3Rt=null;
    this.saveiolArray.power3Lt=null;
    this.saveiolArray.power4Rt=null;
    this.saveiolArray.power4Lt=null;
    this.saveiolArray.acPcRt =null;
    this.saveiolArray.acPcLt=null;
    this.saveiolArray.iolTypeRt=null;
    this.saveiolArray.iolTypeLt=null;
    this.saveiolArray.modelRt=null;
    this.saveiolArray.modelLt=null;
    this.saveiolArray.entryDate= this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
    this.saveiolArray.finalPowerRt=null;
    this.saveiolArray.finalPowerLt=null;
    this.saveiolArray.iolSizeRt=null;
    this.saveiolArray.iolSizeLt=null;
    this.saveiolArray.planoRt=null;
    this.saveiolArray.planoLt=null;
    this.saveiolArray.lensThicknessRt=null;
    this.saveiolArray.lensThicknessLt=null;
    this.saveiolArray.acdRt=null;
    this.saveiolArray.acdLt=null;
    this.saveiolArray.specularMicroscopyRt=null;
    this.saveiolArray.specularMicroscopyLt =null;
    this.saveiolArray.hexagonalityRt=null;
    this.saveiolArray.hexagonalityLt=null;
    this.saveiolArray.cellDensityRt=null;
    this.saveiolArray.cellDensityLt=null;
    this.saveiolArray.cellCountRt=null;
    this.saveiolArray.cellCountLt=null;
    this.saveiolArray.emmetropiaLt=null;
    this.saveiolArray.emmetropiaRt=null;
    this.saveiolArray.ammetropiaLt=null;
    this.saveiolArray.ammetropiaRt=null;
    this.saveiolArray.wwlt=null;
    this.saveiolArray.wwrt=null;
    this.saveiolArray.doctor=null;
    this.saveiolArray.oldOptoId=null;
    this.saveiolArray.needtoDiscuss=null;

    this.getIolDetail();
  }
 
  getIolDetail() {
   
    this.detailiolArray = [
    { "srno": 1,  "name": 'K1 Reading', "righteye": this.saveiolArray.k1Rt ? this.saveiolArray.k1Rt : null, "lefteye": this.saveiolArray.k1Lt ? this.saveiolArray.k1Lt : null, "enable": true },
    { "srno": 2,  "name": 'K2 Reading', "righteye": this.saveiolArray.k2Rt ? this.saveiolArray.k2Rt : null, "lefteye": this.saveiolArray.k2Lt ? this.saveiolArray.k2Lt : null, "enable": true },
    { "srno": 3,  "name": 'K1-Axis', "righteye": this.saveiolArray.k1AxisRt ? this.saveiolArray.k1AxisRt : null, "lefteye": this.saveiolArray.k1AxisLt ? this.saveiolArray.k1AxisLt : null, "enable": true },
    { "srno": 4,  "name": 'K2-Axis', "righteye": this.saveiolArray.k2AxisRt ? this.saveiolArray.k2AxisRt : null, "lefteye": this.saveiolArray.k2AxisLt ? this.saveiolArray.k2AxisLt : null, "enable": true },
    { "srno": 5,  "name": 'Axial Length', "righteye": this.saveiolArray.alRt ? this.saveiolArray.alRt : null, "lefteye": this.saveiolArray.alLt ? this.saveiolArray.alLt : null, "enable": true },
    { "srno": 6,  "name": 'A-Constant', "righteye": this.saveiolArray.aConst1Rt ? this.saveiolArray.aConst1Rt : null, "lefteye": this.saveiolArray.aConst1Lt ? this.saveiolArray.aConst1Lt : null, "enable": true },
    { "srno": 7,  "name": 'Power', "righteye": this.saveiolArray.power1Rt ? this.saveiolArray.power1Rt : null, "lefteye": this.saveiolArray.power1Lt ? this.saveiolArray.power1Lt : null, "enable": true },
    { "srno": 8,  "name": 'A-Constant', "righteye": this.saveiolArray.aConst2Rt ? this.saveiolArray.aConst2Rt : null, "lefteye": this.saveiolArray.aConst2Lt ? this.saveiolArray.aConst2Lt : null, "enable": true },
    { "srno": 9,  "name": 'Power', "righteye": this.saveiolArray.power2Rt ? this.saveiolArray.power2Rt : null, "lefteye": this.saveiolArray.power2Lt ? this.saveiolArray.power2Lt : null,  "enable": true },
    { "srno": 10,  "name": 'A-Constant', "righteye": this.saveiolArray.aConst3Rt ? this.saveiolArray.aConst3Rt : null, "lefteye": this.saveiolArray.aConst3Lt ? this.saveiolArray.aConst3Lt : null, "enable": true },
    { "srno": 11,  "name": 'Power', "righteye": this.saveiolArray.power3Rt ? this.saveiolArray.power3Rt : null, "lefteye": this.saveiolArray.power3Lt ? this.saveiolArray.power3Lt : null, "enable": true },
    { "srno": 12,  "name": 'A-Constant', "righteye": this.saveiolArray.aConst4Rt ? this.saveiolArray.aConst4Rt : null, "lefteye": this.saveiolArray.aConst4Lt ? this.saveiolArray.aConst4Lt : null,"enable": true },
    { "srno": 13,  "name": 'Power', "righteye": this.saveiolArray.power4Rt ? this.saveiolArray.power4Rt : null, "lefteye": this.saveiolArray.power4Lt ? this.saveiolArray.power4Lt : null, "enable": true },
    { "srno": 14,  "name": 'AC/PC', "righteye": this.saveiolArray.acPcRt ? this.saveiolArray.acPcRt : null, "lefteye": this.saveiolArray.acPcLt ? this.saveiolArray.acPcLt : null, "enable": true },
    { "srno": 15,  "name": 'Type of IOL', "righteye": this.saveiolArray.iolTypeRt ? this.saveiolArray.iolTypeRt : null, "lefteye": this.saveiolArray.iolTypeLt ? this.saveiolArray.iolTypeLt : null, "enable": true },
    { "srno": 16,  "name": 'Company of IOL', "righteye": this.saveiolArray.modelRt ? this.saveiolArray.modelRt : null, "lefteye": this.saveiolArray.modelLt ? this.saveiolArray.modelLt : null,  "enable": true },
    { "srno": 17,  "name": 'Final Power', "righteye": this.saveiolArray.finalPowerRt ? this.saveiolArray.finalPowerRt : null, "lefteye": this.saveiolArray.finalPowerLt ? this.saveiolArray.finalPowerLt : null, "enable": true },
    { "srno": 18,  "name": 'Optic Dioptor', "righteye": this.saveiolArray.iolSizeRt ? this.saveiolArray.iolSizeRt : null, "lefteye": this.saveiolArray.iolSizeLt ? this.saveiolArray.iolSizeLt : null, "enable": true },
    { "srno": 19, "name": 'Plano/Bio', "righteye": this.saveiolArray.planoRt ? this.saveiolArray.planoRt : null, "lefteye": this.saveiolArray.planoLt ? this.saveiolArray.planoLt : null, "enable": true },
    { "srno": 20,  "name": 'LensThickNess', "righteye": this.saveiolArray.lensThicknessRt ? this.saveiolArray.lensThicknessRt : null, "lefteye": this.saveiolArray.lensThicknessLt ? this.saveiolArray.lensThicknessLt : null,  "enable": true },
    { "srno": 21,  "name": 'ACD', "righteye": this.saveiolArray.acdRt ? this.saveiolArray.acdRt : null, "lefteye": this.saveiolArray.acdLt ? this.saveiolArray.acdLt : null, "enable": true },
    { "srno": 22,  "name": 'SpecularMicroscopy', "righteye": this.saveiolArray.specularMicroscopyRt ? this.saveiolArray.specularMicroscopyRt : null, "lefteye": this.saveiolArray.specularMicroscopyLt ? this.saveiolArray.specularMicroscopyLt : null, "enable": true },
    { "srno": 23,  "name": 'Hexagonality', "righteye": this.saveiolArray.hexagonalityRt ? this.saveiolArray.hexagonalityRt : null, "lefteye": this.saveiolArray.hexagonalityLt ? this.saveiolArray.hexagonalityLt : null, "enable": true },
    { "srno": 24,  "name": 'CellDensity', "righteye": this.saveiolArray.cellDensityRt ? this.saveiolArray.cellDensityRt : null, "lefteye": this.saveiolArray.cellDensityLt ? this.saveiolArray.cellDensityLt : null,  "enable": true },
    { "srno": 25,  "name": 'CellCount', "righteye": this.saveiolArray.cellCountRt ? this.saveiolArray.cellCountRt : null, "lefteye": this.saveiolArray.cellCountLt ? this.saveiolArray.cellCountLt : null, "enable": true }];


  }

  Editdata(i) {
    this.detailiolArray[i].enable = false;
  }
  closeEdit(i) {
    this.detailiolArray[i].enable = true;
  }
  changedata(name:any, srno, i, type) {
  
    if (srno == 1 && type == 'R') {
      this.detailiolArray[i].k1Rt = name;
      this.saveiolArray.k1Rt = name;
    } else if (srno == 1 && type == 'L') {
      this.detailiolArray[i].k1Lt = name;
      this.saveiolArray.k1Lt = name;
    } else if (srno == 2 && type == 'R') {
      this.detailiolArray[i].k2Rt = name;
      this.saveiolArray.k2Rt = name;
    } else if (srno == 2 && type == 'L') {
      this.detailiolArray[i].k2Lt = name;
      this.saveiolArray.k2Lt = name;
    } else if (srno == 3 && type == 'R') {
      this.detailiolArray[i].k1AxisRt = name;
      this.saveiolArray.k1AxisRt = name;
    } else if (srno == 3 && type == 'L') {
      this.detailiolArray[i].k1AxisLt = name;
      this.saveiolArray.k1AxisLt = name;
    } else if (srno == 4 && type == 'R') {
      this.detailiolArray[i].k2AxisRt = name;
      this.saveiolArray.k2AxisRt = name;
    } else if (srno == 4 && type == 'L') {
      this.detailiolArray[i].k2AxisLt = name;
      this.saveiolArray.k2AxisLt = name;
    } else if (srno == 5 && type == 'R') {
      this.detailiolArray[i].alRt = name;
      this.saveiolArray.alRt = name;
    } else if (srno == 5 && type == 'L') {
      this.detailiolArray[i].alLt = name;
      this.saveiolArray.alLt = name;
    }else if (srno == 6 && type == 'R') {
      this.detailiolArray[i].aConst1Rt = name;
      this.saveiolArray.aConst1Rt = name;
    } else if (srno == 6 && type == 'L') {
      this.detailiolArray[i].aConst1Lt = name;
      this.saveiolArray.aConst1Lt = name;
    }else if (srno == 7 && type == 'R') {
      this.detailiolArray[i].power1Rt = name;
      this.saveiolArray.power1Rt = name;
    } else if (srno == 7 && type == 'L') {
      this.detailiolArray[i].power1Lt = name;
      this.saveiolArray.power1Lt = name;
    }else if (srno == 8 && type == 'R') {
      this.detailiolArray[i].aConst2Rt = name;
      this.saveiolArray.aConst2Rt = name;
    } else if (srno == 8 && type == 'L') {
      this.detailiolArray[i].aConst2Lt = name;
      this.saveiolArray.aConst2Lt = name;
    }else if (srno == 9 && type == 'R') {
      this.detailiolArray[i].power2Rt = name;
      this.saveiolArray.power2Rt = name;
    } else if (srno == 9 && type == 'L') {
      this.detailiolArray[i].power2Lt = name;
      this.saveiolArray.power2Lt = name;
    }else if (srno == 10 && type == 'R') {
      this.detailiolArray[i].aConst3Rt = name;
      this.saveiolArray.aConst3Rt = name;
    } else if (srno == 10 && type == 'L') {
      this.detailiolArray[i].aConst3Lt = name;
      this.saveiolArray.aConst3Lt = name;
    }else if (srno == 11 && type == 'R') {
      this.detailiolArray[i].power3Rt = name;
      this.saveiolArray.power3Rt = name;
    } else if (srno == 11 && type == 'L') {
      this.detailiolArray[i].power3Lt = name;
      this.saveiolArray.power3Lt = name;
    }else if (srno == 12 && type == 'R') {
      this.detailiolArray[i].aConst4Rt = name;
      this.saveiolArray.aConst4Rt = name;
    } else if (srno == 12 && type == 'L') {
      this.detailiolArray[i].aConst4Lt = name;
      this.saveiolArray.aConst4Lt = name;
    }else if (srno == 13 && type == 'R') {
      this.detailiolArray[i].power4Rt = name;
      this.saveiolArray.power4Rt = name;
    } else if (srno == 13 && type == 'L') {
      this.detailiolArray[i].power4Lt = name;
      this.saveiolArray.power4Lt = name;
    }else if (srno == 14 && type == 'R') {
      this.detailiolArray[i].acPcRt = name;
      this.saveiolArray.acPcRt = name;
    } else if (srno == 14 && type == 'L') {
      this.detailiolArray[i].acPcLt = name;
      this.saveiolArray.acPcLt = name;
    }else if (srno == 15 && type == 'R') {
      this.detailiolArray[i].iolTypeRt = name;
      this.saveiolArray.iolTypeRt = name;
    } else if (srno == 15 && type == 'L') {
      this.detailiolArray[i].iolTypeLt = name;
      this.saveiolArray.iolTypeLt = name;
    }else if (srno == 16 && type == 'R') {
      this.detailiolArray[i].modelRt = name;
      this.saveiolArray.modelRt = name;
    } else if (srno == 16 && type == 'L') {
      this.detailiolArray[i].modelLt = name;
      this.saveiolArray.modelLt = name;
    }else if (srno == 17 && type == 'R') {
      this.detailiolArray[i].finalPowerRt = name;
      this.saveiolArray.finalPowerRt = name;
    } else if (srno == 17 && type == 'L') {
      this.detailiolArray[i].finalPowerLt = name;
      this.saveiolArray.finalPowerLt = name;
    }else if (srno == 18 && type == 'R') {
      this.detailiolArray[i].iolSizeRt = name;
      this.saveiolArray.iolSizeRt = name;
    } else if (srno == 18 && type == 'L') {
      this.detailiolArray[i].iolSizeLt = name;
      this.saveiolArray.iolSizeLt = name;
    }else if (srno == 19 && type == 'R') {
      this.detailiolArray[i].planoRt = name;
      this.saveiolArray.planoRt = name;
    } else if (srno == 19 && type == 'L') {
      this.detailiolArray[i].planoLt = name;
      this.saveiolArray.planoLt = name;
    }else if (srno == 20 && type == 'R') {
      this.detailiolArray[i].lensThicknessRt = name;
      this.saveiolArray.lensThicknessRt = name;
    } else if (srno == 20 && type == 'L') {
      this.detailiolArray[i].lensThicknessLt = name;
      this.saveiolArray.lensThicknessLt = name;
    }else if (srno == 21 && type == 'R') {
      this.detailiolArray[i].acdRt = name;
      this.saveiolArray.acdRt = name;
    } else if (srno == 21 && type == 'L') {
      this.detailiolArray[i].acdLt = name;
      this.saveiolArray.acdLt = name;
    }else if (srno == 22 && type == 'R') {
      this.detailiolArray[i].specularMicroscopyRt = name;
      this.saveiolArray.specularMicroscopyRt = name;
    } else if (srno == 22 && type == 'L') {
      this.detailiolArray[i].specularMicroscopyLt = name;
      this.saveiolArray.specularMicroscopyLt = name;
    }else if (srno == 23 && type == 'R') {
      this.detailiolArray[i].hexagonalityRt = name;
      this.saveiolArray.hexagonalityRt = name;
    } else if (srno == 23 && type == 'L') {
      this.detailiolArray[i].hexagonalityLt = name;
      this.saveiolArray.hexagonalityLt = name;
    }else if (srno == 24 && type == 'R') {
      this.detailiolArray[i].cellDensityRt = name;
      this.saveiolArray.cellDensityRt = name;
    } else if (srno == 24 && type == 'L') {
      this.detailiolArray[i].cellDensityLt = name;
      this.saveiolArray.cellDensityLt = name;
    }else if (srno == 25 && type == 'R') {
      this.detailiolArray[i].cellCountRt = name;
      this.saveiolArray.cellCountRt = name;
    } else if (srno == 25 && type == 'L') {
      this.detailiolArray[i].cellCountLt = name;
      this.saveiolArray.cellCountLt = name;
    }
  }
  saveIoLData(){
   
    let payload={"OpdIolPower":this.saveiolArray
  }
   this.emrService.insertiolData(payload).pipe(takeUntil(this.destroyiol$)).subscribe((x:any)=>{
    this.dashboardService.openSnackBar(this.saveiolArray.pK_IOLId==0?"Record Saved Successfully":"Record Updated Successfully","ok");
    this.getIolSaveDetail(0, this.emrService.visitid);
  },err=>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  });
  }
  
  disUserHelplist(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        typeid: type,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyiol$)).subscribe((result) => {
      if (result != 0) {
        this.saveiolArray.userName = result;
       
      }
    });
  }
}
